export const clerkAppearance = {
    layout: {
        logoImageUrl: '/images/logo-with-text2.svg',
        logoPlacement: 'inside',
        logoLinkUrl: '/',
    },
    variables: {
        colorBackground: '#22345A',
        colorPrimary: '#356AC8',
        colorText: '#E3E7ED',
        colorTextSecondary: '#A6B2C9',
        colorInputBackground: '#182946',
        colorInputText: '#FFFFFF',
        colorNeutral: '#E3E7ED',
        colorDanger: '#fa5252',
        colorSuccess: '#40c057',
        colorWarning: '#fab005',
        borderRadius: '8px',
        fontFamily: 'Roboto, sans-serif',
    },
    elements: {
        rootBox: { width: '100%' },
        logoBox: {
            height: 'auto',
            justifyContent: 'center',
            padding: '0 0 4px',
            marginTop: -10,
        },
        logoImage: {
            height: 80,
            maxWidth: '90%',
            width: 'auto',
        },
        card: {
            backgroundColor: '#22345A',
            boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
            border: '1px solid #3B4D74',
        },
        headerTitle: { color: '#E3E7ED' },
        headerSubtitle: { color: '#A6B2C9' },
        socialButtonsBlockButton: {
            backgroundColor: '#182946',
            border: '1px solid #3B4D74',
            color: '#E3E7ED',
            '&:hover': { backgroundColor: '#22345A' },
        },
        socialButtonsBlockButtonText: { color: '#E3E7ED' },
        dividerLine: { backgroundColor: '#3B4D74' },
        dividerText: { color: '#A6B2C9' },
        formFieldLabel: { color: '#E3E7ED' },
        formFieldInput: {
            backgroundColor: '#182946',
            border: '1px solid #3B4D74',
            color: '#FFFFFF',
            '&:focus': { borderColor: '#356AC8' },
        },
        formButtonPrimary: {
            backgroundColor: '#356AC8',
            '&:hover': { backgroundColor: '#285096' },
        },
        footerActionText: { color: '#A6B2C9' },
        footerActionLink: { color: '#689DFB', '&:hover': { color: '#8EB6FC' } },
        identityPreviewText: { color: '#E3E7ED' },
        identityPreviewEditButton: { color: '#689DFB' },
        formResendCodeLink: { color: '#689DFB' },
    },
}
